import { render } from "./sunset.vue?vue&type=template&id=e6b9f438&scoped=true"
import script from "./sunset.vue?vue&type=script&lang=ts"
export * from "./sunset.vue?vue&type=script&lang=ts"

import "./sunset.vue?vue&type=style&index=0&id=e6b9f438&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e6b9f438"

export default script